import { evaluatorAuth } from './auth-server/auth'
import { adminBundleEvaluation } from './exams/admin-bundle-evaluation'
import { bundlesEvaluation } from './exams/bundles-evaluation'
import { openApis } from './exams/open-apis'

export const EXAMS = {
  adminBundleEvaluation,
  bundlesEvaluation,
  openApis,
}

export const AUTH = {
  evaluatorAuth,
}
